import { Button, Checkbox, Col, Modal, Row, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import apiNotificaciones from "../../../api/Notificaciones/api-notificaciones";
import { INotificacion } from "../../../models/Notificaciones/notificaciones.model";
import { RootState } from "../../../redux/reducers";
import { TemplateContext } from "../../../utils/template_context";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

interface IModalConvocatorias {
    openModal: boolean,
    setOpenModal: Function,
    tipoConvocatoria: number,
    tipoNotificacion: string
}



export const ModalConvocatorias = ({ openModal, setOpenModal, tipoConvocatoria, tipoNotificacion }: IModalConvocatorias) => {
    const context = useContext(TemplateContext);
    const [openModalExitoso, setOpenModalExitoso] = useState(false);

    const [convocatorias, setConvocatorias] = useState<any>([]);

    const { idParticipante } = useSelector((state: RootState) => state.participantes);

    const getConvocatorias = async (tipoConvocatoria: number) => {
        try {
            // 
            const { data } = await apiConvocatorias.consultaConvocatoriasProcesoAbiertas(tipoConvocatoria);
            const filterConvocatoriasAbiertas = data.filter((c: any) => c.tipo == tipoConvocatoria);
            const filter = filterConvocatoriasAbiertas.map((c: any, idx: number) => {
                return {
                    ...c,
                    index: idx,
                    checked: false
                }
            })
            setConvocatorias(filter)
        } catch (error) {
            console.log(error);
        }
    }

    const itemRenderTable = (current: any, type: any, originalElement: any) => {
        if (type === "prev") {
            return (
                <span className="border-ant-prev-table font-size-10px">
                    <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
                    Ant.
                </span>
            );
        }
        if (type === "next") {
            return (
                <span className="border-ant-prev-table font-size-10px">
                    Sig.
                    <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
                </span>
            );
        }
        return originalElement;
    };


    const handleConvocatoriaSelect = (value: any, datos: any) => {
        let convocatoriasFilter = convocatorias.map((x: any) => {
            if (x.index === datos.index) {
                return {
                    ...x,
                    checked: value
                }
            }

            return {
                ...x
            }
        })
        setConvocatorias(convocatoriasFilter)
    }

    const handleAllConvocatorias = (value: any) => {
        let convocatoriasFilter = convocatorias.map((x: any) => {
            return {
                ...x,
                checked: value
            }
        })
        setConvocatorias(convocatoriasFilter)
    }


    useEffect(() => {
        let mounted = true;
        if (mounted) {
            getConvocatorias(tipoConvocatoria)
        }
        return () => {
            mounted = false;
        }
    }, [])

    const columns: any = [
        {
            title: 'Nombre convocatoria',
            dataIndex: 'nombre_convocatoria',
        },
        {
            width: 150,
            fixed: context.device === "lg" ? "right" : false,
            title: () => (
                <>
                    <Row justify="center">
                        <Col>
                            Seleccionar todo
                        </Col>
                    </Row>
                    <Row justify="center">
                        <Col>
                            <Checkbox onChange={(e) => handleAllConvocatorias(e.target.checked)}></Checkbox>
                        </Col>
                    </Row>
                </>
            ),
            render: (datos: any) => (
                <Row justify="center">
                    <Col>
                        <Checkbox checked={datos.checked} onChange={(e) => handleConvocatoriaSelect(e.target.checked, datos)}></Checkbox>
                    </Col>
                </Row>
            ),
        },
    ];



    const [loading, setLoading] = useState(false);
    const sendNotification = () => {
        let convocatoriasCheck = convocatorias.filter((x: any) => x.checked);
        if (convocatoriasCheck.length !== 0) {
            setLoading(true)
            convocatoriasCheck.forEach(async (convocatoria: any) => {
                try {
                    let payload: INotificacion = {
                        tipo_participante: tipoConvocatoria,
                        tipo_notificacion: tipoNotificacion,
                        remitente: idParticipante,
                        convocatoria_id: convocatoria.idconvocatorias,
                    }
                    
                    await apiNotificaciones.enviarNotificacion(payload);
                    setOpenModalExitoso(true);
                    setLoading(false)
                } catch (error) {
                    console.log(error)
                }
            });
        }
    }

    const onCancel = () => {
        setConvocatorias([]);
        setOpenModal(!openModal)
        setOpenModalExitoso(false);
    }

    return (
        <>
            <Modal
                visible={openModal}
                onCancel={onCancel}
                width={1000}
                style={{ top: 50 }}
                maskStyle={{
                    backgroundColor: "rgba(6, 100, 144 ,0.8)",
                }}

                footer={
                    <Row justify="end" gutter={[24, 24]}>
                        <Col>
                            <Button className="button-gray-ghost" onClick={onCancel}>
                                Cancelar
                            </Button>
                        </Col>
                        <Col>
                            <Button loading={loading} className="button-azul-radius" style={{ marginRight: "20px !important" }} onClick={sendNotification}>
                                Enviar notificación
                            </Button>
                        </Col>
                    </Row>
                }
            >
                <div className="row ">
                    <div className="col-12">
                        <div className="title_in_card no-padding-top font-size-14px font-family-Montserrat-SemiBold" >Convocatorias abiertas / proceso</div>
                    </div>
                    <div className="col-12">
                        <Table
                            pagination={{ style: { marginBottom: "0px" }, position: ["bottomRight"], itemRender: itemRenderTable, pageSize: 20 }}
                            columns={columns}
                            size="small"
                            rowClassName="sizeTable table-row"
                            className="table-ant-design-modify"
                            bordered={false}
                            dataSource={convocatorias}
                            scroll={{ y: 300 }}

                        />
                    </div>
                </div>
            </Modal>
            {openModalExitoso &&
                <Modal
                    visible={openModalExitoso}
                    onCancel={onCancel}
                    style={{ top: 70 }}
                    maskStyle={{
                        backgroundColor: "rgba(24,154,93)",
                    }}
                    footer={
                        <Row justify="center">
                            <Button className="button-azul-radius" onClick={onCancel}>
                                Aceptar
                            </Button>
                        </Row>
                    }
                >
                    <Row style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Col className="font-size-22px font-family-Montserrat-SemiBold" style={{ color: '#2F7E05' }}>
                            Proceso exitoso
                        </Col>
                        <Col className="font-size-14px font-family-Work-Sans font-color-1B1C1D">
                            Las notificaciones se han enviado exitosamente
                        </Col>
                    </Row>
                </Modal>
            }
        </>
    )
}
